module.exports = __webpack_public_path__ + "static/img/domainlogo.2af09c5e.png";